<style lang="scss" scoped>
.menu_main_outer{
  text-transform: capitalize;
  position: fixed;
  height: 80px;
  display: flex;
  padding: 15px 0 10px;
  align-items: center;
  justify-content: space-between;
  border: 0px solid #e4e4e4;
    width: 100%;
    background: #FFF;
    z-index: 11;
  a{
    color:#fff !important;
    text-decoration: none !important;
  }

  .menu_left{
    padding:0px 40px;
    display:flex;
    height:100%;
    img{
      height: 100%;
    }
  }
  .menu_right{
    padding:0px 40px;
    .icon_menu{
      width: 20px;
      height: 20px;
      display: flex;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      cursor:pointer;
      &.icon_open{
        background-image: url(/icond/icon_menu.png);
      }
      &.icon_close{
        background-image: url(/icond/icon_menu_close.png);
      }
    }
  }
}
.submenu{
  padding:60px 42px 65px;
  color: #FFFFFF;
  display:none;
  position: absolute;
  top:100%;
  margin-top:0px;
  width:100%;
  min-height: 200px;
  background: #2A3E6D;
  z-index: 100;
  &.active{
    display:block;
    max-height: calc(100vh - 65px);
    overflow: auto;
  }
  .menu_0_title{
    font-size:32px;
    position:relative;
    border-bottom: 1px solid #feffff;

    .mt0_text{
      position:relative;
      padding-right: 20px;
      cursor:pointer;
      .caret_sm{
        position: absolute;
        top: 14px;
        right: 2px;
        font-size: 18px;
      }
    }
  }
  .submenu_0_outer{
    position:relative;
  }

  .submenu_1{
    padding:0px;
    transition: 0.9s;
    max-height:0px;
    overflow: hidden;
    transition: max-height 0.15s ease-out;
    &.active{
      max-height:2000px;
      transition: max-height 0.45s ease-in;
    }

    .submenu_1_inner{
      padding:20px;
    }
    .submenu_1_text{
      font-size:24px;
      line-height:36px;
      margin:3px 0px;
      cursor:pointer;
    }
  }
  .submenu_2{
    padding: 0 1em 1em;
    .submenu_2_text{
      font-size:16px;
      line-height: 24px;
      font-weight: 100;
    }
  }
}
.menu_top{
  padding: 16px 0;
  width: 100%;
  display: flex;
  margin: 0 -12px;
  z-index:111;
  .mb_li{
    padding:12px 12px;
    font-size: 16px;
    line-height: 21px;
  }
}
</style>

<template>
  <div class='menu_main_outer' v-if="menuLang">
    <div class="menu_left" v-if="logoSrc && url">
      <a :href="url">
        <img :src="logoSrc">
      </a>
    </div>
    <div ref="menuBtns" class="menu_right" v-if="logoSrc && url">
      <template v-if="!showMenu">
        <i class="icon_menu icon_open" @click="toggleOpenMenu"></i>
      </template>
      <template v-else>
        <i class="icon_menu icon_close" @click="toggleOpenMenu"></i>
      </template>
    </div>
    <div ref="menuDrop" class="submenu" :class="{active: showMenu}">
      <div class="container">
        <div class="container" v-if='menuExtLang'>
          <div class="row">
          <!--
            <div class="menu_top">
              <div class="mb_li" v-for='emenu in menuExtLang'>
                <a :href='emenu.url'>
                  {{ emenu.name }}
                </a>
              </div>
              <div class="mb_li">
                <LanguageSelector 
                  ref="langSelector" 
                  :openLangMenu.sync="openLangMenu"
                />
              </div>
            </div>
          -->
          </div>
        </div>
        <div class="row">
          <template v-for="menu0, index in menuLang">
            <div class="col-md-4">
              <div class="submenu_0_outer">
                <div class="menu_0_title">
                  <span class="mt0_text" @click="toggleSubmenu(index)">
                    {{ menu0.name }}
                    <i v-if="showSubmenu[index]" class="fa fa-caret-down caret_sm" aria-hidden="true"></i>
                    <i v-else class="fa fa-caret-right caret_sm" aria-hidden="true"></i>
                  </span>
                </div>
                <template v-if="menu0.childs">
                  <div v-if="menu0.childs.length" class="submenu_1" :class="{'active': showSubmenu[index]}">
                    <div class="submenu_1_inner">
                      <template v-for="menu1 in menu0.childs">
                        <div class='submenu_1_outer'>
                          <div class='submenu_1_text'>
                            <a @focus="setFocusMainManu(index)" :href="menu1.url">
                              {{ menu1.name }}
                            </a>
                          </div>
                          <template v-if="menu1.childs">
                            <div v-if="menu1.childs.length" class="submenu_2">
                              <div class='submenu_2_text' v-for="menu2 in menu1.childs">
                                <a @focus="setFocusMainManu(index)" :href="menu2.url">
                                  {{ menu2.name }}
                                </a>
                              </div>
                            </div>
                          </template>
                        </div>
                      </template>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageSelector from "vueComponents/LanguageSelector";

export default {
  components:{
    LanguageSelector
  },
  props:{
    menuExt:{
      type: Array | Object,
      default(){
        return null;
      }
    },
    menu:{
      type: Array | Object,
      default(){
        return null;
      }
    },
    logoSrc:{
      type: String,
      default: null
    },
    url:{
      type: String,
      default: null
    }
  },
  data() {
    return {
      showMenu: false,
      showSubmenu: {},
      openLangMenu: false,
    };
  },
  computed: {
    issetOpenedMenu(){
      return Object.keys(this.showSubmenu).length? true : false;
    },
    lang(){
      return window.siteLanguage;
    },
    menuLang(){
      if(!this.menu){
        return null;
      }
      return this.menu[this.lang];
    },
    menuExtLang(){
      if(!this.menuExt){
        return null;
      }
      return this.menuExt[this.lang];
    }
  },
  mounted () {
    window.tempMenu = this;
  },
  watch:{
    openLangMenu(){
      if(this.openLangMenu){
        this.showSubmenu = {};
      }
    },
    showSubmenu(){
      if(this.issetOpenedMenu){
        this.openLangMenu = false;
      }
    },
  },
  methods: {
    setFocusMainManu(index){
      this.showSubmenu = {};
      this.$set(this.showSubmenu, index, true);
    },
    toggleSubmenu(index){
      let cur = this.showSubmenu[index]? this.showSubmenu[index] : false;
      this.showSubmenu = {};
      this.$set(this.showSubmenu, index, !cur);
    },
    toggleOpenMenu(){
      this.showMenu = !this.showMenu;
        document.getElementsByTagName('body')[0].classList.remove('menu-open');
        if(this.showMenu){
          document.getElementsByTagName('body')[0].classList.add('menu-open');
      }
    },
    documentClick(e){
      let el1 = this.$refs.menuDrop;
      let el2 = this.$refs.menuBtns;
      let target = e.target;
      let notClose = false;
      if(el1){
        if((el1 === target) || el1.contains(target)) {
          notClose = true;
        }
      }
      if(el2){
        if((el2 === target) || el2.contains(target)) {
          notClose = true;
        }
      }
      if(!notClose){
        this.showMenu = false;
          document.getElementsByTagName('body')[0].classList.remove('menu-open');
      }
    }
  },
  created () {
    document.addEventListener('click', this.documentClick);
  },
  destroyed () {
    document.removeEventListener('click', this.documentClick);
  }
}
</script>
